/**
 * Team Module
 *
 * Exports for team account management with seat-based access.
 */

// Types
export type {
  Team,
  TeamMember,
  TeamInvite,
  TeamRole,
  TeamMemberStatus,
} from './types';

// Constants
export {
  BASE_SEAT_COUNT,
  ADDITIONAL_SEATS_BY_TIER,
  INVITE_EXPIRY_DAYS,
  ROLE_NAMES,
  ROLE_DESCRIPTIONS,
} from './types';

// Helpers
export {
  generateInviteToken,
  isInviteExpired,
  getTotalSeats,
  canManageTeam,
  canRemoveRole,
  formatMemberSince,
} from './types';

// Store
export {
  useTeamStore,
  useTeam,
  useMyRole,
  useActiveMembers,
  usePendingInvites,
  useUsedSeats,
} from './team-store';
